import React, { Component } from 'react';

import NavBar from '../../components/navigation/NavBar';
import ApiResponse from '../../components/message/ApiResponse';

import { 
	OPTIONS_GET_API_URL, OPTIONS_SAVE_API_URL,
	performApiRequest 
} from '../../util/restapi';
import { validInteger } from '../../util/tools';

import iconSpinner from '../../assets/icons/spinner-snake.gif';

const FORM_STATE_INIT = 'init';
const FORM_STATE_INIT_ERROR = 'initError';
const FORM_STATE_COLLECT_DATA = 'collect';
const FORM_STATE_SAVING = 'saving';
const FORM_STATE_SAVING_COMPLETE = 'savingComplete';

class OptionsPage extends Component {
	
	limitSessionCount = { name: 'limitSessionCount', width: '50px', input: '', value: null, valid: true, bgColor: 'white'};
	limitByteCount = { name: 'limitByteCount', width: '100px', input: '', value: null, valid: true, bgColor: 'white'};
	limitTotalByteCount = { name: 'limitTotalByteCount', width: '100px', input: '', value: null, valid: true, bgColor: 'white'};
	limitProductCount = { name: 'limitProductCount', width: '50px', input: '', value: null, valid: true, bgColor: 'white'};
	limitTotalProductCount = { name: 'limitTotalProductCount', width: '50px', input: '', value: null, valid: true, bgColor: 'white'};
	options = {
		sendWhiteList: false,
		limitSessionCount: this.limitSessionCount.value,
	}
	restapiResponse = null
	
	constructor(props) {
		super(props);
		this.state = {
			dirtyCount: 0,
			formState: FORM_STATE_INIT,
		};
	}
	componentDidMount = async () => {
		document.title = 'BOM. Параметри системи';
		let response = await performApiRequest( OPTIONS_GET_API_URL, {optionId: "main"} );
		if( response.success ) {
			this.options = response.data.options;
			this.limitSessionCount.input = this.limitSessionCount.value = this.options.limitSessionCount; 
			this.limitByteCount.input = this.limitByteCount.value = this.options.limitByteCount; 
			this.limitTotalByteCount.input = this.limitTotalByteCount.value = this.options.limitTotalByteCount; 
			this.limitProductCount.input = this.limitProductCount.value = this.options.limitProductCount; 
			this.limitTotalProductCount.input = this.limitTotalProductCount.value = this.options.limitTotalProductCount; 
			this.setState({
				formState: FORM_STATE_COLLECT_DATA,
			});
		} else {
			this.restapiResponse = response;
			this.setState({formState: FORM_STATE_INIT_ERROR})
		}
	}

	handleCheckBoxChange = (e) => {
		const {name, checked} = e.target;
		if( name == 'whiteList' )
			this.options.sendWhiteList = checked;
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleValueChange = e => {
		const {name, value} = e.target;
		if( name == 'limitSessionCount' ) {
			this.handleLimitValueChange( this.limitSessionCount, value );
		} else if( name == 'limitByteCount' ) {
			this.handleLimitValueChange( this.limitByteCount, value );
		} else if( name == 'limitTotalByteCount' ) {
			this.handleLimitValueChange( this.limitTotalByteCount, value );
		} else if( name == 'limitProductCount' ) {
			this.handleLimitValueChange( this.limitProductCount, value );
		} else if( name == 'limitTotalProductCount' ) {
			this.handleLimitValueChange( this.limitTotalProductCount, value );
		} 
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}
	handleLimitValueChange = (limit, value) => {
		limit.input = value; 
		limit.valid = validInteger( value );
		if( limit.valid ) {
			limit.value = value;
			limit.bgColor = 'white';
		} else {
			limit.value = null;
			limit.bgColor = 'lightyellow';
		}
		this.options[limit.name] = limit.value;
	}
	
	save = async () => {
		this.setState({formState: FORM_STATE_SAVING});
		this.restapiResponse = await performApiRequest( OPTIONS_SAVE_API_URL, {options: this.options} );
		this.setState({formState: FORM_STATE_SAVING_COMPLETE})
	}
	continueWork = () => {
		this.setState({formState: FORM_STATE_COLLECT_DATA});
	}

	render() {
		let formBodyHtml = null;
		if( this.state.formState == FORM_STATE_INIT ) {
			formBodyHtml = (
				<div style={{margin: '50px 0 50px 0'}}>
					<img src={iconSpinner} />
				</div>
			);
		} else if( this.state.formState == FORM_STATE_INIT_ERROR ) {
			formBodyHtml = (
				<ApiResponse response={this.restapiResponse} />
			)
		} else if( this.state.formState == FORM_STATE_SAVING ) {
			formBodyHtml = (
				<div>
					<div style={{marginBottom: '15px', textAlign: 'center'}}>
						Збереження даних...
					</div>
					<div style={{margin: '10px 0 10px 0'}}>
						<img src={iconSpinner} />
					</div>
				</div>
			)
		} else if( this.state.formState == FORM_STATE_SAVING_COMPLETE ) {
			formBodyHtml = (
				<div>
					<ApiResponse response={this.restapiResponse} defaultMessage='Успішно збережено' />
					<div style={{marginTop: '10px', textAlign: 'right'}}>
						<button type='button' onClick={this.continueWork} 
							style={{padding: '3px 10px 3px 10px'}}
						>
							Продовжити
						</button>
					</div>
				</div>
			)
		} else if( this.state.formState == FORM_STATE_COLLECT_DATA ) {
			let disabled = false;
			formBodyHtml = (
				<div>
					<div style={{marginBottom: '15px', textAlign: 'left'}}>
						<input type='checkbox' name='whiteList' onChange={this.handleCheckBoxChange} 
							checked={this.options.sendWhiteList}
						/>
						<span style={{marginLeft: '5px'}}>Автоматично надсилати "білий список"</span>
					</div>
					<div style={{marginBottom: '15px', padding: '15px', textAlign: 'left', border: '1px solid blue'}}>
						<div>
							Ліміти для ONIX повідомлень
						</div>
						<div style={{marginLeft: '15px', textAlign: 'left'}}>
							<div style={{marginTop: '10px'}}>
								Кількість запитів за добу
								<LimitInput limit={this.limitSessionCount} handleValueChange={this.handleValueChange} />
							</div>
							<div style={{marginTop: '10px'}}>
								Кількість байт в одному запиті
								<LimitInput limit={this.limitByteCount} handleValueChange={this.handleValueChange} />
								<span style={{marginLeft: '20px'}}></span>
								Кількість байт за добу
								<LimitInput limit={this.limitTotalByteCount} handleValueChange={this.handleValueChange} />
							</div>
							<div style={{marginTop: '10px'}}>
								Кількість продуктів в одному запиті
								<LimitInput limit={this.limitProductCount} handleValueChange={this.handleValueChange} />
								<span style={{marginLeft: '20px'}}></span>
								Кількість продуктів за добу
								<LimitInput limit={this.limitTotalProductCount} handleValueChange={this.handleValueChange} />
							</div>
						</div>
					</div>
					<div style={{marginTop: '10px', textAlign: 'right'}}>
						<button type='button' onClick={this.save} disabled={disabled}
							style={{padding: '3px 10px 3px 10px'}}
						>
							Записати
						</button>
					</div>
				</div>
			);
		}
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<div style={localStyles.divMain}>
					<div style={{marginBottom: '15px', fontWeight: 'bold', fontSize: '14pt'}}>
						Параметри системи
					</div>
					{formBodyHtml}
				</div>
			</React.Fragment>
		)
	}	
}

function LimitInput(props) {
	let limit = props.limit;
	return (
		<input name={limit.name} type='text' 
			style={{marginLeft: '10px', width: limit.width, backgroundColor: limit.bgColor}}
			value={limit.input} onChange={props.handleValueChange}
		/>
	);
}

const localStyles = {
	divMain: {
		width: '1000px', 
		border: '1px solid blue', 
		marginLeft: 'auto', 
		marginRight: 'auto',
		marginTop: '20px',
		marginBottom: '20px',
		padding: '10px'
	},
};


export default OptionsPage;
